import React from 'react'
import Layout from '../../../components/corporateAdmin/Layout'
import Chart from '../../../components/ui/demo/Chart'
import { Helmet } from 'react-helmet'

function Employee() {
    return (
        <div>
            <Layout>
              <Helmet>
                    <title>Admin - Employee</title>
                </Helmet>
                <Chart title="Employee satisfaction & Feedback Summary"/>
            </Layout>
        </div>
    )
}

export default Employee
